<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />

    <div>
      <div class="bodyCenter">
        <div class="modalStyle">
          <div class="titulos">
            <div class="seccionTitle">
              <b-icon icon="person-lines-fill" class="mLeft"></b-icon>
              <div class="headerTxt mLeft">Movimientos de Saldo</div>
            </div>
            <div class="alignIcon bold">BJ_01_Autorizar Movimiento</div>
          </div>

          <div class="flxDivs">
            <div class="div20">
              <b-form-group label="Clínica" class="mginTop10">
                <v-select
                  class="mginTop10"
                  :clearable="false"
                  :options="listaClinicas"
                  v-model="cliId"
                  :reduce="(variable) => variable.id"
                  label="nombre"
                  placeholder="Selecciona una clínica"
                >
                </v-select>
              </b-form-group>
            </div>
            <div class="div80">
              <b-skeleton-table
                :rows="5"
                :columns="5"
                :table-props="{ bordered: true, striped: true }"
                v-if="cargandoTabla == true"
              ></b-skeleton-table>
              <span v-if="arrayTraspasos.length != 0">
                <b-table
                  thead-tr-class="columnas"
                  responsive
                  striped
                  hover
                  :items="arrayTraspasos"
                  v-if="arrayTraspasos.length != 0 && cargandoTabla == false"
                >
                  <template #cell(Autorizar)="row">
                    <b-button
                      variant="primary"
                      @click="
                        actualizarEstatus(
                          row.item.Folio,
                          2,
                          null,
                          row.item.Monto
                        )
                      "
                    >
                      <em class="fa fa-check-circle"></em>
                    </b-button>
                  </template>
                  <template #cell(Rechazar)="row">
                    <b-button
                      variant="primary"
                      @click="abrirDetalle(row.item.Folio, 3, row.item.Monto)"
                    >
                      <em class="fa fa-times-circle"></em>
                    </b-button>
                  </template>
                </b-table>
                <br />
                <br />
              </span>
              <strong
                v-if="arrayTraspasos.length == 0 && cargandoTabla == false"
                >Sin solicitudes</strong
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-detalle" hide-footer>
      <template #modal-title>Rechazo de modificación de saldo</template>
      <div class="d-block text-left">
        <b-form-group
          label="Especifica la razón por la cual rechazas la modificación"
          class="mginTop10"
        >
          <b-form-textarea
            v-model="razon"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </b-form-group>
        <b-button
          variant="outline-primary"
          :disabled="razon == null"
          @click="actualizarEstatus(folio, status, razon, monto)"
        >
          Guardar
        </b-button>
      </div>
      <b-button class="mt-3" block @click="$bvModal.hide('modal-detalle')"
        >Cerrar</b-button
      >
    </b-modal>
  </div>
</template>
<script>
//components
import Header from "../../components/Header.vue";
//import miniToastr from "mini-toastr"; //ES6

export default {
  name: "bandejaContabilidadSaldo",
  components: {
    Header,
  },
  props: {
    msg: String,
    isDark: Boolean,
    "md-active-step": String,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    cliId: null,
    listaClinicas: [],
    cargandoTabla: false,
    arrayTraspasos: [],
    info: {},
    estatusId: null,
    loading: false,
    folio: null,
    monto: null,
    status: null,
    razon: null,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.llenarClinicas();
    this.ObtenerTraspasos(null);
  },
  methods: {
    abrirDetalle(folio, status, monto) {
      this.folio = folio;
      this.monto = monto;
      this.status = status;
      this.$bvModal.show("modal-detalle");
    },
    llenarClinicas() {
      this.$http
        .get(this.$api + "catalogos/listaClinicas")
        .then((response) => {
          if (response.status === 200) {
            this.listaClinicas = response.data.data
              .map((it) => {
                return {
                  id: it.idClinica,
                  nombre: it.strNombre,
                };
              })
              .filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);

            this.listaClinicas.push({ id: null, nombre: "TODAS" });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    actualizarEstatus(folio, estatusId, mensaje, monto) {
      this.$swal
        .fire({
          title: "¿Estás seguro de actualizar el estatus?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          showLoaderOnConfirm: true,
          preConfirm: () => {
            this.loading = true;
            this.$http
              .put(
                this.$api +
                  "saldo/actualizarTraspaso?idEstatusTraspaso=" +
                  estatusId +
                  "&idTraspaso=" +
                  folio +
                  "&idUsuario=" +
                  this.$localStorageService.getIdUsuario() +
                  "&comentario=" +
                  mensaje +
                  "&monto=" +
                  monto
              )
              .then(() => {
                this.ObtenerTraspasos();
              })
              .catch((error) => {
                console.error(error);
                this.banderaBtn = false;
                this.$swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Error",
                });
              })
              .finally(() => {
                this.loading = false;
                location.reload();
              });
          },
        })
        .then((result) => {
          if (result.value) {
            this.$swal({
              icon: "success",
              title: "Se actualizó correctamente",
              showConfirmButton: false,
              timer: 2500,
              onClose: () => {
                this.$bvModal.hide("modal-detalle");
              },
            });
          }
        });
    },
    ObtenerTraspasos(idClinica) {
      this.arrayTraspasos = [];
      this.cargandoTabla = true;
      this.$http
        .get(
          this.$api + "saldo/obtenerMovimientosPorEstatus?idEstatusTraspaso=5",
          {
            params: {
              idClinica: idClinica,
            },
          }
        )
        .then((response) => {
          this.cargandoTabla = false;
          if (response.status === 200) {
            this.arrayTraspasos = response.data.data.map((it) => {
              return {
                Folio: it.idTraspaso,
                Clínica: it.clinicaNombre,
                Paciente: it.pacienteNombre,
                Monto: it.monto,
                Autorizar: true,
                Rechazar: true,
              };
            });
          }
        })
        .catch((error) => {
          this.cargandoTabla = false;
          console.error(error);
        });
    },
  },
  watch: {
    cliId: function () {
      this.ObtenerTraspasos(this.cliId);
    },
  },
};
</script>
<style scoped>
.inputIconDiv {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.title_hist {
  font-weight: bolder;
  font-size: 25px;
  color: #053672;
}

.colorInfo {
  color: #ffc107;
}

.info {
  margin-top: 10px;
  background-color: #fff87c;
  border: 2px solid #fbb917;
  padding: 10px;
  border-radius: 10px;
}

.flxDivs {
  display: flex;
  flex-direction: row;
  padding-top: 20px;
  padding-bottom: 20px;
  justify-content: space-around;
}

.div20 {
  width: 25%;
  border: 2px solid #b9cde6;
  padding: 1%;
  border-radius: 12px;
}

.div80 {
  width: 73%;
  border: 2px solid #b9cde6;
  padding: 1%;
  border-radius: 12px;
}

.txtCard {
  padding-left: 16px !important;
}
</style>
